export default __webpack_public_path__ + "static/media/login_google.87d88619.jpg";